import $ from 'jquery';

const $searchButton = $( '.search__filter--search-button' );
const $searchInput = $( '.search__filter--search > input' );

$searchButton.on( 'click', () => {
	if ( $searchInput.val().length > 0 ) {
		$searchInput.change();
	}
} );
